"use client";

import Link from "next/link";
import Image from "next/image";
import { Search, User, Heart, ShoppingCart, Grid3x3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";

export function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-gray-800 bg-[#0A1929] text-white">
      {/* Main Header */}
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center gap-6">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded border-2 border-cyan-500">
              <div className="grid grid-cols-2 gap-[2px]">
                <div className="h-2 w-2 bg-cyan-500"></div>
                <div className="h-2 w-2 bg-cyan-500"></div>
                <div className="h-2 w-2 bg-cyan-500"></div>
                <div className="h-2 w-2 bg-cyan-500"></div>
              </div>
            </div>
            <span className="text-xl font-bold">TahaComputers</span>
          </Link>

          {/* Shop by Category Button */}
          <Button
            variant="outline"
            className="border-gray-700 bg-transparent hover:bg-gray-800"
          >
            <Grid3x3 className="mr-2 h-4 w-4" />
            Shop by Category
          </Button>

          {/* Search Bar */}
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
            <Input
              type="search"
              placeholder="Search for CPUs, GPUs, Laptops..."
              className="w-full border-gray-700 bg-white pl-10 text-gray-900 placeholder:text-gray-500"
            />
          </div>

          {/* User Actions */}
          <div className="flex items-center gap-4">
            {/* User Account */}
            <Button
              variant="ghost"
              size="icon"
              className="hover:bg-gray-800"
              aria-label="User account"
            >
              <User className="h-5 w-5" />
            </Button>

            {/* Wishlist */}
            <Button
              variant="ghost"
              size="icon"
              className="relative hover:bg-gray-800"
              aria-label="Wishlist"
            >
              <Heart className="h-5 w-5" />
              <Badge
                variant="destructive"
                className="absolute -right-1 -top-1 h-5 min-w-[20px] rounded-full px-1 text-xs"
              >
                12
              </Badge>
            </Button>

            {/* Shopping Cart */}
            <Button
              variant="default"
              size="icon"
              className="relative bg-cyan-600 hover:bg-cyan-700"
              aria-label="Shopping cart"
            >
              <ShoppingCart className="h-5 w-5" />
              <Badge
                variant="destructive"
                className="absolute -right-1 -top-1 h-5 min-w-[20px] rounded-full px-1 text-xs"
              >
                3
              </Badge>
            </Button>
          </div>
        </div>
      </div>

      {/* Navigation Links */}
      <div className="border-t border-gray-800 bg-[#0d1f33]">
        <div className="container mx-auto px-4">
          <nav className="flex h-12 items-center gap-8 text-sm">
            <Link
              href="/deals"
              className="transition-colors hover:text-cyan-400"
            >
              Deals
            </Link>
            <Link
              href="/pc-builder"
              className="transition-colors hover:text-cyan-400"
            >
              PC Builder
            </Link>
            <Link
              href="/custom-pcs"
              className="transition-colors hover:text-cyan-400"
            >
              Custom PCs
            </Link>
            <Link
              href="/new-arrivals"
              className="transition-colors hover:text-cyan-400"
            >
              New Arrivals
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
